export default {
  path: '/xy/mini-app',
  title: '微信小程序',
  icon: 'folder-o',
  children: (pre => [
    { path: `${pre}dictItem`, title: '字典项管理' },
    { path: `${pre}indexImg`, title: '首页轮播图管理' },
    { path: `${pre}article`, title: '用药指导管理' },
    { path: `${pre}goodsInf`, title: '药品信息管理' },
    { path: `${pre}cancer`, title: '疾病管理' },
    { path: `${pre}userList`, title: '注册用户管理' }
  ])('/xy/mini-app/')
}
